import { useState, useEffect } from 'react'
import Modal from './Modal'
import Boton from './Boton'
import BuscadorCliente from './BuscadorCliente'
import ModalListaClientes from './ModalListaClientes'
import { pagosApi } from '../api/pagos'
import { etiquetaCliente } from '../utils/cliente'
import { colors, text, space, radius, sx } from '../design/tokens'

/**
 * Cambiar el cliente de un recibo A CUENTA (Martin, 22 sep 2026). La regla y
 * sus frenos viven en el backend (PagoService::cambiarCliente): un recibo
 * imputado lleva el cliente de su venta, y uno ya emitido en Presea solo
 * acepta la ficha a nombre de la cual lo tiene Presea. F6 = búsqueda avanzada.
 */
export default function ModalCambiarClienteRecibo({ pago, onClose, onSaved }) {
  const [cliente, setCliente] = useState(null)
  const [avanzada, setAvanzada] = useState(false)
  const [guardando, setGuardando] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const h = (e) => { if (e.key === 'F6') { e.preventDefault(); setAvanzada(true) } }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [])

  const guardar = async () => {
    setGuardando(true); setError('')
    try {
      const { data } = await pagosApi.cambiarCliente(pago.id, cliente.id)
      onSaved(data)
    } catch (err) {
      const errs = err.response?.data?.errors
      setError(errs ? Object.values(errs).flat().join(' ') : (err.response?.data?.message || 'No se pudo cambiar el cliente.'))
    } finally { setGuardando(false) }
  }

  return (
    <Modal title="Cambiar el cliente del recibo" onClose={onClose} maxWidth="560px">
      <div style={{ display: 'flex', flexDirection: 'column', gap: space.lg }}>
        <div style={{ fontSize: text.body, color: colors.textSec }}>
          Hoy: <strong style={{ color: colors.text }}>{etiquetaCliente(pago.cliente)}</strong>
          {pago.numero_presea && (
            <div style={{ marginTop: space.xs, fontSize: text.sec }}>
              El recibo <span style={sx.mono}>{pago.numero_presea}</span> ya está en Presea: solo se acepta la ficha a nombre de la cual lo tiene Presea (LGR lo verifica).
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: space.sm, alignItems: 'flex-start' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <BuscadorCliente key={cliente?.id || 'sin'} value={cliente} onChange={setCliente} />
          </div>
          <Boton variante="secondary" sm onClick={() => setAvanzada(true)} title="Búsqueda avanzada de cliente (F6): nombre, CUIT, DNI, localidad, email">🔍</Boton>
        </div>
        {cliente && (
          <div style={{ fontSize: text.sec, color: colors.textSec }}>
            Nuevo: <strong style={{ color: colors.text }}>{etiquetaCliente(cliente)}</strong> · Nº cliente <span style={sx.mono}>{cliente.codigo_presea || 'pendiente'}</span>
          </div>
        )}
        {error && <div style={{ padding: '8px 12px', borderRadius: radius.md, background: colors.errBg, color: colors.err, fontSize: text.body }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: space.sm }}>
          <Boton variante="ghost" onClick={onClose}>Cancelar</Boton>
          <Boton variante="primary" disabled={!cliente || guardando} onClick={guardar}>{guardando ? 'Cambiando…' : 'Cambiar e imputar →'}</Boton>
        </div>
      </div>
      {avanzada && (
        <ModalListaClientes onSelect={(c) => { setCliente(c); setAvanzada(false) }} onClose={() => setAvanzada(false)} />
      )}
    </Modal>
  )
}
